<template>
	<div class="prayerContainer">
        <BaseStructuredPrayerList :prayers="structuredPrayerList" v-slot="prayer">
            <PrayerAdminDisplay :prayer="prayer" @delete="removePrayer" class = "prayerDiv" />
        </BaseStructuredPrayerList>
	</div>
</template>

<script setup>

import {defineProps} from "vue";


import {useAdminPrayerList } from "@/composables/prayerList";
import {useStore} from "vuex";
import BaseStructuredPrayerList from "./BaseStructuredPrayerList.vue";
import PrayerAdminDisplay from "./PrayerAdminDisplay.vue";

const props = defineProps(["client"]);
const {state} = useStore();
const {prayerList, structuredPrayerList} = useAdminPrayerList(props.client, state.userToken);


function removePrayer(prayer){
	let index = prayerList.value.findIndex(element => {
		return prayer.prayerId == element.prayerId;
	})

	
	if(index > -1){
		prayerList.value.splice(index, 1);
	}
	
}


</script>


<style scoped>

.prayerContainer{
	font-weight: 700;
	margin-left: auto;
	margin-right: auto;
	text-align: left;
	max-width: 90vw;
	width: 800px;

}

</style>